import React, { useEffect } from 'react';
import './ProfileInfo.css';

const ProfileInfo = ({ isOpen, onClose, Profile }) => {
    // Empêcher le scroll du body quand la popup est ouverte

    useEffect(() => {
    }, [Profile]);
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    // Ne rien afficher si la popup est fermée
    if (!isOpen) return null;

    return (
        <div>
            <div className='header-profile'>

                <figure>
                    <img src={Profile.urlphoto} />
                </figure>
                <div className='header-text'>
                    <h2>
                        {Profile.name}
                        <div className='peripheral-stats'>
                            <span className={`mic-status ${Profile.mic_state ? 'mic-active' : 'mic-inactive'}`}>
                                {Profile.mic_state ?
                                    <span className="material-symbols-outlined">
                                        mic
                                    </span>
                                    :
                                    <span className="material-symbols-outlined">
                                        mic_off
                                    </span>
                                }
                            </span>

                            <span className={`participent-camera-status ${Profile.camera_state ? 'cam-active' : 'cam-inactive'}`}>
                                {Profile.camera_state ?
                                    <span className="material-symbols-outlined">
                                        videocam
                                    </span>
                                    :
                                    <span className="material-symbols-outlined">
                                        videocam_off
                                    </span>
                                }
                            </span>
                        </div>
                    </h2>
                    <span>{Profile.email}</span>
                </div>
            </div>
            <div className='body-profile'></div>
        </div>
    );
};

export default ProfileInfo;
